module.exports = __webpack_public_path__ + "img/screen-recording.c207209c.svg";